import { render, staticRenderFns } from "./b-link.global.vue?vue&type=template&id=26450694"
import script from "./b-link.global.vue?vue&type=script&lang=js"
export * from "./b-link.global.vue?vue&type=script&lang=js"
import style0 from "./b-link.global.vue?vue&type=style&index=0&id=26450694&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports